module.exports = __webpack_public_path__ + "img/trash_blue.35b02f83.svg";